export const INCIDENTS_TEST_IDS = {
 INCIDENTS_FILTER_ICON_BUTTON: "incidents_filterIconButton",
 INCIDENTS_RESOLVE_BUTTON: "incidents_resolveButton",
};